export const followUser = (followerID, followedUser) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    firestore
      .collection("follow")
      .doc(followerID)
      .set(
        {
          users: firestore.FieldValue.arrayUnion(followedUser),
        },
        { merge: true }
      )
      .then(() => {
        dispatch({ type: "FOLLOW_USER_SUCCESS" });
      })
      .catch((err) => {
        dispatch({ type: "FOLLOW_USER_ERROR", err });
      });
  };
};

export const checkFollowList = (userID, followID) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    firestore
      .collection("follow")
      .doc(userID)
      .get()
      .then((doc) => {
        if (!doc.exists) {
          console.log("No such document!");
        } else {
          let flag = false;
          doc.data().users.forEach((element) => {
            if (followID == element.uid) {
              flag = true;
            }
          });
          if (flag) {
            dispatch({
              type: "SET_ALREADY_FOLLOWING",
            });
          } else {
            dispatch({
              type: "SET_NOT_ALREADY_FOLLOWING",
            });
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const followUserAfter = (followerID, followedUser) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    firestore
      .collection("follow")
      .doc(followerID)
      .set(
        {
          users: firestore.FieldValue.arrayUnion(followedUser),
        },
        { merge: true }
      )
      .then(() => {
        dispatch({ type: "FOLLOW_USER_SUCCESS_AFTER" });
      })
      .catch((err) => {
        dispatch({ type: "FOLLOW_USER_ERROR_AFTER", err });
      });
  };
};

export const unfollowUser = (followerID, unfollowedUser) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    firestore
      .collection("follow")
      .doc(followerID)
      .update({
        users: firestore.FieldValue.arrayRemove(unfollowedUser),
      })
      .then(() => {
        dispatch({ type: "UNFOLLOW_USER_SUCCESS" });
      })
      .catch((err) => {
        dispatch({ type: "UNFOLLOW_USER_ERROR", err });
      });
  };
};

export const followWithoutLogIn = (user, userId) => {
  return (dispatch) => {
    dispatch({ type: "FOLLOW_WITHOUT_LOGIN", user: user, userId: userId });
  };
};

export const redirectAfterLogin = () => {
  return (dispatch) => {
    dispatch({ type: "REDIRECT_AFTER_LOGIN" });
  };
};

export const resetRedirectVars = () => {
  return (dispatch) => {
    dispatch({ type: "RESET_REDIRECT_VARS" });
  };
};

export const redirectToOverview = () => {
  return (dispatch) => {
    dispatch({ type: "REDIRECT_OVERVIEW" });
  };
};

export const resetFollowList = () => {
  return (dispatch) => {
    dispatch({ type: "RESET_ALREADY_FOLLOWING" });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/supportActions.tsx